import Alpine from "alpinejs";

Alpine.data("eventTeaser", () => ({
    hover: false,
    box: {
        [":class"]() {
            return this.hover && "bg-gray-200";
        },
    },
    connector: (className) => {
        return {
            [":class"]() {
                return this.hover && className;
            },
            ["@mouseenter"]() {
                this.hover = true;
            },
            ["@focus"]() {
                this.hover = true;
            },
            ["@mouseleave"]() {
                this.hover = false;
            },
            ["@blur"]() {
                this.hover = false;
            },
        };
    },
    link: {
        ["@mouseenter"]() {
            this.hover = true;
        },
        ["@focus"]() {
            this.hover = true;
        },
        ["@mouseleave"]() {
            this.hover = false;
        },
        ["@blur"]() {
            this.hover = false;
        },
    },
}));
